<template>
    <div class="footer fixed-bottom w-100 py-2">
        <div class="container">
            <div class="row text-center">
                <div class="col text-uppercase">
                    <router-link :to="{name: 'Portfolio'}">
                        <div class="icon-container">
                            <img v-if="$route.name == 'Portfolio'" class="d-block mx-auto mb-2" src="@/assets/images/icons/file.svg" width="20" />
                            <img v-else class="d-block mx-auto mb-2" src="@/assets/images/icons/empty-file.svg" width="20" />
                        </div>
                        <span class="font-weight-bold" :class="{'color-secondary' : $route.name == 'Portfolio'}">Portfolio</span>
                    </router-link>
                </div>

                <div class="col text-uppercase">
                    <router-link :to="{name: 'Bookmarks'}">
                        <div class="icon-container">
                                <img v-if="$route.name == 'Bookmarks'" class="d-block mx-auto mb-2" src="@/assets/images/icons/star.svg" width="25" />
                                <img v-else class="d-block mx-auto mb-2" src="@/assets/images/icons/white-star.svg" width="25" />
                        </div>
                        <span class="font-weight-bold" :class="{'color-secondary' : $route.name == 'Bookmarks'}">Bookmarks</span>
                    </router-link>
                </div>

                <div class="col text-uppercase">
                    <router-link :to="{name: 'More'}">
                        <div class="icon-container">
                            <img v-if="$route.name == 'More'" class="d-block mx-auto mb-2" src="@/assets/images/icons/menu-fill.svg" width="25" />
                            <img v-else class="d-block mx-auto mb-2" src="@/assets/images/icons/menu.svg" width="25" />
                        </div>
                        <span class="font-weight-bold" :class="{'color-secondary' : $route.name == 'More'}">More</span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FooterComponent'
}
</script>
